module.exports = __webpack_public_path__ + "static/media/benedict-4.73f4002f.jpg";